import JSZip from 'jszip'
import FileSaver from "file-saver";

export default class DownImg {
    constructor(options, callback) {

        // {
        //     name: '包名',
        //     list: [
        //  {
        //     name:'图片名',
        //     link:'图片地址'
        // }
        //]
        // }

        this.downloadData = options.list
        this.blogTitle = options.name
        this.callback = callback
        this.down()
    }

    down() {
        let downloadData = this.downloadData
        let zip = new JSZip();
        let _this = this
        let imgs = zip.folder(this.blogTitle);
        let baseList = []
        for (let i = 0; i < downloadData.length; i++) {

            let image = new Image();

            // 解决跨域 Canvas 污染问题

            image.setAttribute('crossOrigin', 'anonymous');
            image.onload = function () {
                let canvas = document.createElement('canvas');
                canvas.width = image.width;
                canvas.height = image.height;
                let context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, image.width, image.height);
                let url = canvas.toDataURL(); // 得到图片的base64编码数据
                canvas.toDataURL('image/png');

                for (let index = 0; index < downloadData.length; index++) {
                    const element = downloadData[index];
                    if (image.src.indexOf(element.link) > -1) {
                        // baseList.push(url.substring(22));// 去掉base64编码前的data:image/png;base64,
                        element.baseList = url.replace('data:image/png;base64,', '')
                        baseList.push(' ')
                        break

                    }

                }


                if (baseList.length === downloadData.length && baseList.length > 0) {

                    for (let k = 0; k < baseList.length; k++) {
                        imgs.file(downloadData[k].name + '.png', downloadData[k].baseList, { base64: true })
                    }
                    zip.generateAsync({ type: 'blob' }).then(function (content) {

                        // see FileSaver.js
                        FileSaver.saveAs(content, _this.blogTitle + '.zip');
                        _this.callback ? _this.callback({ code: 'success' }) : ''

                    }).catch(er => {
                        _this.callback ? _this.callback({ code: 'err', msg: er }) : ''
                        console.log(er)

                    })

                }

            };

            image.src = downloadData[i].link;

        }
    }

}